import PropTypes from 'prop-types';

import './NoResults.css';

const NoResults = ({ icon, message }) => {
    return (
        <div className="ab-no-results">
            {icon && icon}
            {message && <div>{message}</div>}
        </div>
    );
};

NoResults.propTypes = {
    icon: PropTypes.node,
    message: PropTypes.string,
};

export default NoResults;
